// extracted by mini-css-extract-plugin
export default {"SideDrawer":"SideDrawer_SideDrawer__R9CA5","Open":"SideDrawer_Open__Eu6Dx","Close":"SideDrawer_Close__55-yd","Logo":"SideDrawer_Logo__0+BrY"};